import { isSecureProctoringProfile } from 'Config/proctoring.config'
import Button from 'antd/lib/button'
import Tooltip from 'antd/lib/tooltip'
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined'
import styles from './ProctoringRecordingBadge.module.less'

const SECURE_BODY =
    'Your screen is being recorded to ensure task integrity. Your data is securely stored and protected under GDPR and our Privacy Policy.'

const STRICT_BODY =
    'Your screen, audio, and webcam are being recorded to ensure task integrity. Your data is securely stored and protected under GDPR and our Privacy Policy.'

export const ProctoringRecordingBadge = ({ profile }: { profile?: string }) => {
    const body = isSecureProctoringProfile(profile) ? SECURE_BODY : STRICT_BODY

    const tooltipTitle = (
        <div className={styles.tooltipContent} data-testid="proctoring-recording-tooltip">
            <div className={styles.panelTitle}>Proctoring in progress</div>
            <div className={styles.panelDivider} />
            <p className={styles.panelBody}>{body}</p>
        </div>
    )

    return (
        <div className={styles.wrap} data-testid="proctoring-recording-badge">
            <div className={styles.badge}>
                <span className={styles.recordIcon} aria-hidden />
                <span className={styles.label}>Recording</span>
                <Tooltip
                    title={tooltipTitle}
                    placement="bottomRight"
                    trigger="hover"
                    mouseEnterDelay={0.05}
                    destroyTooltipOnHide
                    classNames={{ root: styles.tooltipOverlay }}
                >
                    <Button
                        type="text"
                        className={styles.infoBtn}
                        icon={<InfoCircleOutlined />}
                        aria-label="Proctoring information"
                    />
                </Tooltip>
            </div>
        </div>
    )
}
